import React from 'react';
import { BarChart3, RefreshCw } from 'lucide-react';

const NoDataMessage = ({ onRetry }) => {
  return (
    <div className="bg-white rounded-lg p-8 shadow-sm border text-center">
      <div className="text-gray-400 mb-4">
        <BarChart3 className="w-16 h-16 mx-auto" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">No campaigns found</h3>
      <p className="text-gray-600 mb-6">
        Try adjusting your search criteria or date range.
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors mx-auto"
        >
          <RefreshCw className="h-4 w-4 mr-2" />
          Refresh Data
        </button>
      )}
    </div>
  );
};

export default NoDataMessage;